module.exports = __webpack_public_path__ + "assets/closeMobileModal-2a84d2.svg";